import { Component } from '@angular/core';

@Component({
  selector: 'sales-helpful-links',
  templateUrl: './helpful-links.component.html',
  styleUrls: ['./helpful-links.component.scss'],
})
export class HelpfulLinksComponent {}
